import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './Layout';

// Texto de las promociones transcrito de los banners oficiales (assets/img/promociones/large); no editar sin el área comercial/legal.
const VIGENCIA = 'Inicia el 1 de agosto de 2024. Vigencia hasta agotar existencias o hasta que Itmex determine el fin de la promoción.';

const GRUPOS = [
    {
        id: 'contrato',
        titulo: 'Con contrato de 12 meses',
        icono: 'fas fa-file-signature',
        promociones: [
            {
                aplica: 'Básico+',
                imagen: 'fibra-basico',
                etiqueta: 'Instalación',
                precio: '$600',
                extra: 'y primer mes gratis',
                descripcion: <>Recibirán un mes de internet <b>gratis</b> al firmar un contrato de <b>12 meses</b>.</>,
            },
            {
                aplica: 'Premium+, Gold+, Gamer+ y Empresarial',
                imagen: 'fibra-premium',
                etiqueta: 'Instalación',
                precio: 'Gratis',
                extra: 'y mes de internet sin costo',
                descripcion: <>Instalación <b>gratuita</b> y un mes de <b>internet gratis</b> para nuevos clientes con contrato de <b>12 meses</b>.</>,
            },
        ],
    },
    {
        id: 'sin-contrato',
        titulo: 'Sin contrato',
        icono: 'fas fa-unlock',
        promociones: [
            {
                aplica: 'Básico+',
                imagen: 'fibra-gold',
                etiqueta: 'Instalación',
                precio: '$1,200',
                extra: 'y mes gratis sin contrato',
                descripcion: <>Recibirán un <b>mes de internet gratis</b> sin necesidad de firmar un contrato de permanencia.</>,
            },
            {
                aplica: 'Premium+, Gold+, Gamer+ y Empresarial',
                imagen: 'fibra-gamer',
                etiqueta: 'Instalación a precio especial',
                precio: '$600',
                extra: 'y mes de internet sin costo',
                descripcion: <>Precio especial de <b>$600 MXN</b> en instalación para <b>nuevos clientes</b> que contraten planes "Premium+" o superiores. Incluye un mes de internet <b>gratis sin contrato</b> de permanencia.</>,
            },
        ],
    },
];

const PromoCard = ({ promo }) => (
    <article className="promoItmex">
        <div className="promoItmex-figura">
            <img src={`/assets/img/planes/${promo.imagen}.jpg`} alt="" loading="lazy" />
        </div>
        <div className="promoItmex-cuerpo">
            <span className="promoItmex-aplica">Aplica a: {promo.aplica}</span>
            <span className="promoItmex-etiqueta">{promo.etiqueta}</span>
            <span className="promoItmex-precio">{promo.precio}</span>
            <span className="promoItmex-extra">{promo.extra}</span>
            <p className="promoItmex-descripcion">{promo.descripcion}</p>
            <Link className="planItmex-cta promoItmex-cta" to="/contacto">
                Quiero esta promoción
                <span className="planItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
            </Link>
        </div>
    </article>
);

class Promociones extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Promociones">
                    <section className="promosItmex">
                        <div className="planesItmex-header">
                            <span className="planesItmex-eyebrow">Promociones</span>
                            <h1 className="tituloItmex">Promociones de instalación</h1>
                            <p className="planesItmex-subtitulo">Para nuevos clientes, con o sin contrato de permanencia.</p>
                        </div>

                        {GRUPOS.map(grupo => (
                            <div className="promosItmex-grupo" key={grupo.id}>
                                <h2 className="promosItmex-grupo-titulo"><i className={grupo.icono}></i>{grupo.titulo}</h2>
                                <div className="promosItmex-grid">
                                    {grupo.promociones.map(promo => <PromoCard key={promo.aplica + promo.precio} promo={promo} />)}
                                </div>
                            </div>
                        ))}

                        <div className="planesItmex-leyendas promosItmex-leyendas">
                            <p>{VIGENCIA}</p>
                            <p>Consulta los planes en la sección de <a href="/#planesInternet">planes</a> y la <Link to="/cobertura">cobertura</Link> disponible en tu comunidad.</p>
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Promociones;
